import { RouteComponentProps } from '@reach/router';
import React from 'react';

const RouteWrapper: React.FunctionComponent<RouteComponentProps> = props => (
  <>{props.children}</>
);

export default RouteWrapper;
